var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Select, Option, Typography } from "@mui/joy";
export default function ModuleList(_a) {
    var module = _a.module, options = _a.options, onChange = _a.onChange;
    return (_jsx(_Fragment, { children: _jsx(Select, __assign({ slotProps: {
                button: {
                    id: "module-type-button",
                    "aria-labelledby": "module-type-label module-type-button",
                },
            }, startDecorator: _jsx("span", __assign({ className: "px-2 rounded-md bg-slate-200" }, { children: module || "" })), value: module || "", onChange: onChange }, { children: Object.keys(options).map(function (k) { return (_jsx(Option, __assign({ value: k }, { children: _jsx(Typography, __assign({ level: k }, { children: options[k] })) }), k)); }) })) }));
}
